import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { pageAction } from '../../redux_files/actions/page_actions';

const BookYourBuffet = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Book Your Buffet';
    dispatch(pageAction('Book Your Buffet'));
  });
  const menuOptions = [
    { label: 'Book Satvic Buffet', value: 'satvicBuffet', description: 'A healthy satvic thali with organic ingredients.', price: 100, link: '/satvic-buffet' },
    { label: 'Book Other Buffet', value: 'otherBuffet', description: 'Home style/Restaurant style buffet', link: '/other-buffet-options' },
  ];

  const handleTileClick = (value) => {
    navigate(value);
  };

  return (
    <div className='container'>
      <div className="step-section mt-10">
        <div className="step-tiles">
          {menuOptions.map(option => (
            <div
              key={option.value}
              className="step-tile"
              onClick={() => handleTileClick(option.link)}
            >
              <div className="step-tile-label">{option.label}</div>
              <div className="step-tile-desc">{option.description}
                {option.extra && (
                  <div className="step-tile-extra">{option.extra}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

  );
};

export default BookYourBuffet;
